<template>
    <div class="row">
        <div class="col-5">
            <div class="row">
                <div class="col-12">
                    <TitleComponent title="2. Nuevas altas" subtitle="A) Selecciona el sector en la siguiente tabla:"></TitleComponent>
                </div>
                <div class="col-12">
                    <TablaSectoresComponent :zonas="zonas" v-on:goTo="goTo"></TablaSectoresComponent>
                </div>
            </div>
        </div>
        <div class="col-7">
            <template v-if="place.svg_teatros">
                <CleSvgComponent 
                    v-if="zonas.length > 0"
                    :zonas="zonas" 
                    :place="place"
                    @clickZona="goTo"
                ></CleSvgComponent>
            </template>
            <template v-else>
                <MapaSvgComponent 
                    :zonas="zonas" 
                    :can_click="true" 
                    :popup_enabled="true" 
                    :occupied="false"
                    @clickZona="goTo"
                    :place="place"
                ></MapaSvgComponent>
            </template>

            <h3 v-if="zonas">
                <b>Libres: </b>
                {{ total_libres }}
            </h3>
        </div>
    </div>
</template>

<script>
    import TitleComponent from '@/components/backend/stepper/components/TitleComponent';
    import TablaSectoresComponent from '@/components/backend/stepper/components/TablaSectoresComponent';
    import MapaSvgComponent from '@/components/backend/stepper/components/MapaSvgComponent';
    import CleSvgComponent from '@/components/backend/stepper/components/CleSvgComponent';

    export default {
        props: ['place'],
        data() {
            return {
                loading: true,
                search: null,
                zonas: null
            }
        },
        created() {
            this.getZonas();
        },
        computed: {
            total_libres() {
                var total = 0;

                if(this.zonas && this.zonas.length > 0) {
                    for (var i = 0; i < this.zonas.length; i++) {
                        if(this.zonas[i].name != 'internacional' && this.zonas[i].name != 'Internacional' && this.zonas[i].name != 'Baby' && this.zonas[i].name != 'INTERNACIONAL' && this.zonas[i].esta_disponible) {
                            var libres = this.zonas[i].with_seats ? this.zonas[i].total_asientos : this.zonas[i].aforo;

                            libres = libres - this.zonas[i].bloqueados - this.zonas[i].confirmados - this.zonas[i].no_confirmados - this.zonas[i].sesion;

                            total = total + libres;
                        }
                    }
                }

                return total;
            }
         },
        methods: {
            getZonas() {
                const params = {
                    filters: {
                        place_id: this.place.id
                    },
                    place_id: this.place.id
                };
                this.$store.dispatch(this.config.getVuexAlias('zonas.index'), params).then(res => {
                    this.zonas = res.data;
                });
            },
            goTo(paso, zona) {
                this.$emit('goTo', paso, zona, null);
            }
        },
        components: {
            TitleComponent, TablaSectoresComponent, MapaSvgComponent, CleSvgComponent
        }
    }
</script>

<style>

</style>
